import { deviceType, primaryInput } from 'detect-it';
/**
 * Returns the current device type.
 */
function getDeviceType() {
    return deviceType;
}
/**
 * Returns if the device type is hybrid, meaning that it supports both mouse and touch interactions.
 */
function isHybridDevice() {
    return deviceType === 'hybrid';
}
/**
 * Returns if the device only supports mouse interactions.
 */
function isMouseOnlyDevice() {
    return deviceType === 'mouseOnly';
}
/**
 * Returns if the device only supports touch interactions.
 */
function isTouchOnlyDevice() {
    return deviceType === 'touchOnly';
}
/**
 * Returns the primary input method of the device.
 */
function getPrimaryInput() {
    return primaryInput;
}
/**
 * Returns if the primary input method of the device is by mouse.
 */
function isPrimaryInputMouse() {
    return primaryInput === 'mouse';
}
/**
 * Returns if the primary input method of the device is by touch.
 */
function isPrimaryInputTouch() {
    return primaryInput === 'touch';
}
export { getDeviceType, getPrimaryInput, isHybridDevice, isMouseOnlyDevice, isPrimaryInputMouse, isPrimaryInputTouch, isTouchOnlyDevice, };
//# sourceMappingURL=device-capabilities.js.map